module.exports = __webpack_public_path__ + "img/log_sms_sendmagic.4c024b1a.png";